// Batch status fetch for in-flight finalize jobs (Stage 3d).
//
// One POST returns the status of every in-flight finalize job, so
// the upload page polls once per cycle instead of once per job. The
// polling loop itself lives in MastersUpload.js — this is just the
// fetch. Returns the `jobs` array; each item:
//   { job_id, status, master_id, error_text,
//     phash_present, audio_present, created_at, updated_at }
// Jobs not found / not owned are simply absent from the array.
export async function fetchFinalizeStatusBatch({ apiBase, jobIds, appToken }) {
  const res = await fetch(`${apiBase}/api/masters/finalize/status`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${appToken}`,
    },
    body: JSON.stringify({ job_ids: jobIds }),
  });
  if (!res.ok) throw new Error(`status poll failed (HTTP ${res.status})`);
  const data = await res.json();
  return Array.isArray(data.jobs) ? data.jobs : [];
}
